import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {Safedoc} from "./safedoc.pipe";
import {Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {WebCamComponent} from 'ack-angular-webcam';
import {RemovehtmltagPipe} from "../../patient-chart/patient-chart-parent/patient-emr/emr-cpoe/cpoe-doctoradvice/RemovehtmltagPipe.pipe";
@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [Safedoc,WebCamComponent,RemovehtmltagPipe],
  exports:      [ Safedoc,WebCamComponent ,RemovehtmltagPipe]
})
export class SafeUrlModule { }



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/shared/custom-pipe/safe-url.module.ts